import React from "react";
import { Plus, MessageSquare, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";

export function ChatSidebar({ chats, currentId, onNew, onOpen, onDelete }) {
  return (
            <aside className="lg:col-span-3 bg-white border border-slate-200 rounded-2xl p-3 h-fit" data-testid="chat-sidebar">
              <Button
                onClick={onNew}
                data-testid="new-chat-btn"
                className="w-full rounded-xl bg-[#1E3A8A] hover:bg-[#1E40AF] text-white justify-start gap-2"
              >
                <Plus size={16} /> New chat
              </Button>
              <div className="mt-3 space-y-1 max-h-[60vh] overflow-y-auto adv-scroll-hide">
                {chats.length === 0 && <p className="text-xs text-slate-400 text-center py-6">No chats yet</p>}
                {chats.map((c) => (
                  <div
                    key={c.id}
                    className={`group flex items-center gap-2 px-3 py-2 rounded-lg cursor-pointer text-sm ${currentId === c.id ? "bg-blue-50 text-[#1E3A8A]" : "hover:bg-slate-50 text-slate-700"}`}
                    onClick={() => onOpen(c.id)}
                    data-testid={`chat-item-${c.id}`}
                  >
                    <MessageSquare size={14} />
                    <span className="flex-1 truncate font-medium">{c.title}</span>
                    <button
                      onClick={(e) => { e.stopPropagation(); onDelete(c.id); }}
                      className="opacity-0 group-hover:opacity-100 text-slate-400 hover:text-red-500"
                      data-testid={`delete-chat-${c.id}`}
                    >
                      <Trash2 size={14} />
                    </button>
                  </div>
                ))}
              </div>
            </aside>
  );
}
